import * as React from "react"
import { Col } from "react-grid-system"
import styled from "styled-components"
import { Spacer } from "../atoms/spacers"
import { theme } from "../theme"
import H3 from "../atoms/typography/H3"
import { CheckCircleIcon } from "../atoms/icons/CheckCircleIcon"

interface Props {
  email: string
}

const ContentContainer = styled.div`
  padding: ${(props) => props.theme.spacings.large};
  background-color: ${(props) => props.theme.colors.greyLight};
  border-radius: ${(props) => props.theme.borders.softRadius};
  display: flex;
`

const InvitationSentEmail: React.FunctionComponent<Props> = ({ email }) => {
  return (
    <Col md={3}>
      <ContentContainer>
        <H3>{email}</H3>
        <Spacer spacing={1} />
        <div style={{ display: "flex", alignItems: "center" }}>
          <CheckCircleIcon />
        </div>
      </ContentContainer>
    </Col>
  )
}

export default InvitationSentEmail
